import { PDFDocument, degrees } from "pdf-lib";

// pages: [{ src, idx, rot, blank, landscape }], sources: { key: { bytes } }
export async function buildBinderPdf(pages, sources) {
    const out = await PDFDocument.create();
    const loaded = {};
    for (const p of pages) {
        if (p.blank) {
            const pg = out.addPage(p.landscape ? [842, 595] : [595, 842]);
            if (p.rot) pg.setRotation(degrees(p.rot));
            continue;
        }
        if (!loaded[p.src]) loaded[p.src] = await PDFDocument.load(sources[p.src].bytes.slice(0), { ignoreEncryption: true });
        const [cp] = await out.copyPages(loaded[p.src], [p.idx]);
        cp.setRotation(degrees((((cp.getRotation().angle || 0) + p.rot) % 360 + 360) % 360));
        out.addPage(cp);
    }
    return out.save();
}
